// The distance ring: Nearkin's one signature mark (decision 50). A radius is the
// product's real mechanic, so the mark is concentric arcs, 1 to 3 of them.
export const RING_SIZES = [16, 24, 96] as const;
export type RingSize = (typeof RING_SIZES)[number];

// Small sizes stay legible with fewer arcs; the 96px illustration earns all three.
export function ringArcCount(size: RingSize, arcs?: 1 | 2 | 3): 1 | 2 | 3 {
  return arcs ?? (size === 16 ? 1 : size === 24 ? 2 : 3);
}

// Three quarters of a circle, anticlockwise from 3 o'clock to 6 o'clock the long
// way round, leaving the bottom-right quadrant open like a radar sweep.
export function arcPath(center: number, r: number): string {
  return `M ${center + r} ${center} A ${r} ${r} 0 1 0 ${center} ${center + r}`;
}
